// extracted by mini-css-extract-plugin
export default {"modal":"wTI1N___Modal-module__modal"};